import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getApiErrorMessage } from '@noor/api';
import { toast } from '@noor/lib';
import { orderNoteApi, orderNoteKeys } from '@/entities/order-note';
import { ordersKeys } from '@/entities/order';

/**
 * Create an order note. Posts `{order_id, text, type:'cencel'}` (the `'cencel'`
 * typo is a backend literal — preserved). On success, invalidates the note list
 * (refreshes the dialog) AND the order list (the "last note" column).
 */
export function useCreateNote(orderId: string | number) {
  const { t } = useTranslation('orders');
  const queryClient = useQueryClient();

  return useMutation({
    meta: { suppressErrorToast: true },
    mutationFn: (text: string) =>
      orderNoteApi.create({ order_id: orderId, text, type: 'cencel' }),
    onSuccess: () => {
      toast.success(t('notes.createdSuccess'));
      void queryClient.invalidateQueries({ queryKey: orderNoteKeys.list(orderId) });
      void queryClient.invalidateQueries({ queryKey: ordersKeys.lists() });
    },
    onError: (error) => toast.error(getApiErrorMessage(error, t('notes.createError'))),
  });
}
